import * as Highcharts from "highcharts"
import { applyHighchartsTheme } from "../utils/highcharts_theme"

export function renderCostComparisonChart(el, chartData) {
  applyHighchartsTheme(Highcharts)

  const currencySymbol = chartData.currency_symbol || ""
  const barWidth = 90
  const sideMargin = Math.max(0, (el.clientWidth - 2.2 * barWidth) / 2)
  const paddingPercentage = el.clientHeight > 0 ? 1 + 20 / el.clientHeight : 1.1
  const maxValue = chartData.max_value * paddingPercentage

  const isClientPortal = chartData.is_client_portal === true

  return Highcharts.chart(el, {
    chart: {
      type: "column",
      // Highcharts 13 changed the default chart.backgroundColor to the CSS var
      // `var(--highcharts-background-color)`, which resolves to a near-black
      // value under prefers-color-scheme: dark (or to an invalid SVG fill,
      // i.e. black, since we run in non-styled mode). Set it explicitly so the
      // chart stays transparent over the white card regardless of OS theme.
      backgroundColor: "transparent",
      marginLeft: sideMargin,
      marginRight: sideMargin,
      marginTop: 0,
      marginBottom: 0,
    },
    title: false,
    xAxis: {
      categories: chartData.categories,
      labels: {
        enabled: false,
      },
      lineWidth: 0,
    },
    yAxis: {
      min: 0,
      max: maxValue,
      title: {
        enabled: false,
      },
      offset: 0,
      labels: {
        enabled: false,
      },
      gridLineColor: "transparent",
    },
    legend: {
      enabled: false,
    },
    tooltip: {
      ...(isClientPortal && { style: { fontSize: "12px" } }),
      pointFormatter: function () {
        return (
          '<span style="color:' +
          this.color +
          '">\u25CF</span> ' +
          "<b>" +
          currencySymbol +
          Highcharts.numberFormat(this.y, 2) +
          "</b><br/>"
        )
      },
    },
    plotOptions: {
      column: {
        pointWidth: barWidth,
        borderWidth: 0,
        colorByPoint: true,
        dataLabels: {
          enabled: true,
          crop: false,
          overflow: "allow",
          ...(isClientPortal && {
            style: { fontSize: "12px", fontWeight: "normal" },
          }),
          formatter: function () {
            var decimals = chartData.show_cents ? 2 : 0
            return currencySymbol + Highcharts.numberFormat(this.y, decimals)
          },
        },
      },
    },
    series: chartData.series,
    credits: { enabled: false },
  })
}

export function initCostComparisonCharts() {
  document
    .querySelectorAll('[data-chart="cost-comparison"]:not([phx-hook])')
    .forEach((el) => {
      renderCostComparisonChart(el, JSON.parse(el.dataset.chartData))
    })
}
